/**
 * DisposalPage — the Disposal top-level page (Phase 21 / Task 21.7 follow-up): disposal
 * companies (portal status, the ten paid modules, activation) and the self-registration queue.
 * PLATFORM_ADMIN only (MANAGE_DISPOSAL_PORTAL_ACCESS on every route it calls). Billing for these
 * companies stays on the Billing page; each company links there.
 */
import * as React from 'react';
import { useUrlParam } from '../../lib/url-state';
import { Button } from 'src/components/ui/button';
import { subText } from '../../ui/bits';
import { DisposalCompaniesTab } from './DisposalCompaniesTab';
import { DisposalRegistrationsTab } from './DisposalRegistrationsTab';
import { TAB_TRACK_STYLE, tabPillStyle } from 'src/components/ui/tab-styles';

type Tab = 'companies' | 'registrations';

export function DisposalPage(): React.JSX.Element {
  // The tab lives in the URL with the tabs' own filters (lib/url-state.ts, Corbin 2026-10-20).
  const [tabParam, setTab] = useUrlParam('tab', 'companies', []);
  const tab = tabParam as Tab;
  return (
    <div style={{ padding: '24px', maxWidth: '1100px', margin: '0 auto' }}>
      <div style={{ marginBottom: '16px' }}>
        <h2 style={{ fontSize: '18px', fontWeight: 600, margin: 0 }}>Disposal</h2>
        <p style={{ ...subText, marginTop: '2px' }}>
          Disposal companies, their portal and paid modules, and new sign-ups to review.
        </p>
      </div>
      <div role="tablist" style={{ ...TAB_TRACK_STYLE, marginBottom: '16px' }}>
        <Button
          role="tab"
          aria-selected={tab === 'companies'}
          variant="ghost"
          style={tabPillStyle(tab === 'companies')}
          onClick={() => setTab('companies')}
        >
          Companies
        </Button>
        <Button
          role="tab"
          aria-selected={tab === 'registrations'}
          variant="ghost"
          style={tabPillStyle(tab === 'registrations')}
          onClick={() => setTab('registrations')}
        >
          Registrations
        </Button>
      </div>
      {tab === 'companies' ? <DisposalCompaniesTab /> : <DisposalRegistrationsTab />}
    </div>
  );
}
